import React, { useEffect, useState } from 'react';
import { Button, Form, Grid, Header, Image, Segment, List, Icon, Dimmer, Loader, Message } from 'semantic-ui-react'
import { Link, Navigate, useParams, useNavigate } from 'react-router-dom';
import API, { ResponseManagement, ErrorManagement } from './../../API';
import Auth from './../../Auth';
import Utility from './../../Utility';
import CheckPassword from './../CheckPassword/CheckPassword';
import { toast } from 'react-toastify';
import CookieBanner from './../Navigation/CookieBanner/CookieBanner';
import 'react-toastify/dist/ReactToastify.css';
import './LoginBox.css';
import {displayToastErrorFromResponse} from "@components/TradsErrorPages/ErrorUtil";
//import Loader from '../../components/Basics/Loader';
/**
 * Components LoginBox
 * @param {object} props.history
 * @param {object} props.login
 * @param {string} props.password
 */

const LoginBox = (props) => {
  let { passwordconfirm, token, lang } = useParams();
  let navigate = useNavigate();

  const [loaderActiveState, setLoaderActiveState] = useState(true);
  // const [stageState, setStageState] = useState('login');
  const [stageState, setStageState] = useState('loginStepEmail');
  const [passwordConfirmState, setPasswordConfirmState] = useState(() => {
    if( passwordconfirm === 'confirm' ){
      return 'passwordConfirmState';
    }
    else if( passwordconfirm === 'initializePassword' ){
      return 'initializePassword';
    }
    else{
      return 'loginStepEmail';
      // return 'login';
    }
  });
  const [dataLoginState, setDataLoginState] = useState({
    login : '',
    password : ''
  });
  const [loginForgotState, setLoginForgotState] = useState('');
  const [establishmentState, setEstablishmentState] = useState({});
  const [logoState, setLogoState] = useState('');
  const [backgroundImageState, setBackgroundImageState] = useState('');
  const [translationsState, setTranslationsState] = useState({});
  const [legalInfoState, setLegalInfoState] = useState({});
  const [newPasswordState, setNewPasswordState] = useState('');
  const [typeInputConfirmPasswordState, setTypeInputConfirmPasswordState] = useState('password');
  const [typeInputConfirmPasswordBisState, setTypeInputConfirmPasswordBisState] = useState('password');
  const [isMailValidState, setIsMailValidState] = useState(true);
  const [customerAreaMailState, setCustomerAreaMailState] = useState(null);
  const [errorPasswordInitState, setErrorPasswordInitState] = useState({
    email: false,
    newPassword: false,
    confirmPassword: false
  });
  const [redirectState, setRedirectState] = useState(false);
  const [redirectLoginState, setRedirectLoginState] = useState(false);
  const [infoUserState, setInfoUserState] = useState({
    civility: false,
    lastName: false,
    firstName: false
  });
  const [affChampCodeVerifState, setAffChampCodeVerifState] = useState(false);
  const [hasDoublonEcState, setHasDoublonEcState] = useState(false);
  const [messageInfoState, setMessageInfoState] = useState('');

  // token etab si connection qui ne vient pas d'un mail
  // sera mis à jour après ajax si match avec customerArea
  const [tokenCustomerAreaState, setTokenCustomerAreaState] = useState(token)
  const [isInitializePasswordWithCodeState, setIsInitializePasswordWithCodeState] = useState(false)

  // erreur MBMVC
  if(lang == 'FR'){
    translationsState.error_mail_doublon = "Cet e-mail est déjà lié à un espace client. Merci de vous connecter ou de réinitialiser votre mot de passe.";
    translationsState.confirmEmail = "Vérification de votre e-mail";
    translationsState.infoConfirmEmail = "Nous avons besoin de vérifier votre e-mail avant de continuer.";
    translationsState.infoConnectToConfirmAccount = "Merci de bien vérifier que cet e-mail vous appartient et d'entrer votre mot de passe pour valider que cette réservation est bien à vous.";
    translationsState.enterCodeToValidIsMyAccount = "Valider votre e-mail.";
    translationsState.hello = "Bonjour";
    translationsState.sendCode = "Envoyer le code";
    translationsState.enterCode = "Entrer le code";
    translationsState.reSendCodeVerif = "Renvoyer le code";
    translationsState.infoEnterCodeToValidMyAccount = "Entrer ici le code qui vient de vous être envoyer par e-mail.";
    translationsState.error_code_non_valid = "Ce code n'est pas valide ou a déjà été utilisé. Cliquez sur « Renvoyer le code » pour en recevoir un nouveau.";
    translationsState.error_code_required = "Merci de saisir le code reçu par e-mail.";
    translationsState.error_initialize_password_token = "Une erreur est survenue lors de la création de votre lien d'accès. Merci de réessayer.";
  }
  else{
    translationsState.error_mail_doublon = "This e-mail is already linked to a customer area. Please login or reset your password.";
    translationsState.confirmEmail = "Checking your e-mail";
    translationsState.infoConfirmEmail = "We need to verify your email before proceeding.";
    translationsState.infoConnectToConfirmAccount = "Please check that this e-mail belongs to you and enter your password to confirm that this reservation is yours.";
    translationsState.enterCodeToValidIsMyAccount = "Validate your email.";
    translationsState.hello = "Hello";
    translationsState.sendCode = "Send code";
    translationsState.enterCode = "Enter code";
    translationsState.reSendCodeVerif = "Return the code";
    translationsState.infoEnterCodeToValidMyAccount = "Enter here the code that has just been sent to you by e-mail.";
    translationsState.error_code_non_valid = "This code is invalid or has already been used. Click \"Return the code\" to receive a new one.";
    translationsState.error_code_required = "Please enter the code received by e-mail.";
    translationsState.error_initialize_password_token = "An error occurred while creating your access link. Please try again.";
  }


  useEffect(() => {
    if(props.login !== undefined || props.password !== undefined) {
      setDataLoginState({
        login : props.login,
        password : props.password
      });
    }
  }, [props.login, props.password]);

  useEffect(() => {
    Auth.resetTabForLogin();
    let typeRequest = 'signIn';
    // if( passwordConfirmState != 'login') {
    if( passwordConfirmState != 'login' && passwordConfirmState != 'loginStepEmail') {
      typeRequest = 'initializePassword';
    }

    API
      .get(`/${token}/${lang}/${typeRequest}`)
      .then(response => {

        ResponseManagement(response,
          () => {
            setEstablishmentState(response.data.data.establishment);
            setTranslationsState(response.data.data.translations);
            setLegalInfoState(response.data.data.legalInfo);

            // chargement des images
            if (response.data.data.espaceClientByOrga && response.data.data.id_etab_reference != response.data.data.establishment.id ) {
              setLogoState( response.data.data.establishmentCollection[ response.data.data.id_etab_reference ].logo );
              setBackgroundImageState(  response.data.data.establishmentCollection[ response.data.data.id_etab_reference ].backgroundImage );
            }
            else{
              setLogoState( response.data.data.establishment.logo );
              setBackgroundImageState(  response.data.data.establishment.backgroundImage );
            }

            if (response.data.data.customerAreaMail !== undefined) {
              setCustomerAreaMailState(response.data.data.customerAreaMail);
            }
            if( passwordConfirmState != 'login' && passwordConfirmState != 'loginStepEmail' ) {
              setIsMailValidState(response.data.data.isMailValid);

              if( !response.data.data.isMailValid ){
                setPasswordConfirmState('confirmEmail');
              }

              if( response.data.data.hasMdp == true && passwordconfirm === 'initializePassword' ){

                // add message
                setMessageInfoState('Un espace client correspond déjà à cette adresse mail, veuillez vous connecter.\n\r Vous pouvez cliquer sur "Mot de passe oublié" pour réinitialiser ce mot de passe.')
                // redirect login
                setPasswordConfirmState('login');
                setRedirectLoginState(true);
              }
            }
            setTimeout(() => {
              setLoaderActiveState(false);
            }, 500);
          },
          () => {
            // erreur MBMVC
            if(lang == 'FR'){
              translationsState.error_authentication_session_link_expired = "Ce lien n'est plus valide, merci de vous connecter";
              translationsState.error_authentication_session_type_not_valid = "Nous ne trouvons pas la page demandée";
              translationsState.error_authentication_session_missing_page_type = "Nous ne trouvons pas la page demandée";
            }
            else{
              translationsState.error_authentication_session_link_expired = "This link is no longer valid, please log in ";
              translationsState.error_authentication_session_type_not_valid = "We cannot find the requested page";
              translationsState.error_authentication_session_missing_page_type = "We cannot find the requested page";
            }
            // message
            if (typeof response.data.message !== "undefined" && response.data.message !== "") {
              toast.error(translationsState[response.data.message]);
            } else {
              displayToastErrorFromResponse(response, 'Page not found')
            }

            setTimeout(() => {
              setLoaderActiveState(false);
              //navigate('/');
              // choix de redirection
              if ( ['error_authentication_session_link_expired',
                    'error_authentication_session_type_not_valid',
                    'error_authentication_session_missing_page_type',
                    'error_authentication_session_missing_link',
                    'error_authentication_session_authentication_status'].includes(response.data.message) ){
                setPasswordConfirmState('login');
                setRedirectLoginState(true);
              }
              else{
                setRedirectState(true);
              }
            }, 5500);
          }
        );
      })
      .catch(error => {
        console.error(error);
        ErrorManagement(error, () => {
          setLoaderActiveState(false);
          setRedirectState(true);
          //setPasswordConfirmState(true);
          //setRedirectLoginState(true);
        });
      });
  }, [token, lang, passwordconfirm]);// eslint-disable-line react-hooks/exhaustive-deps

  /**
   * Set Stage
   * @param {string} stage
   */
  const setStage = (stage) => {
    let listSlide = document.querySelector('.ui.horizontal.list');
    setLoginForgotState('');
    if (stage === 'forgot' || stage === 'first' || stage === 'loginStepPassword') {
      listSlide.classList.add('transitionLogin');
    } else if (stage === 'login') {
      listSlide.classList.remove('transitionLogin');
      listSlide.classList.remove('transitionStepPassword');
    }
    setStageState(stage);
  }

  /**
   * Click sur le lien pour le mot de passe oublié
   * @param {object} event
   */
  const handleClickUrlPassWordforgot = (event) => {
    event.preventDefault();
    // setStage('forgot');
    setMessageInfoState('');
    setLoginForgotState(dataLoginState.login)
    setStageState('forgot');
    setPasswordConfirmState('forgot');
  }

  /**
   * Click sur le lien pour première connexion
   * @param {object} event
   */
  const handleClickUrlFirstConnexion = (event) => {
    event.preventDefault();
    // setStage('first');
    setStageState('first');
    setPasswordConfirmState('first');
  }

  /**
   * Click sur le lien pour revenir sur l'interface de connexion au compte
   * @param {object} event
   */
  const handleClickUrlBack = (event) => {
    event.preventDefault();
    // setStage('login');
    setMessageInfoState('');
    setStageState('loginStepEmail');
    setPasswordConfirmState('loginStepEmail');
  }

  /**
   * Click sur le lien pour rediriger vers la page de login
   * @param {object} event
   */
  const handleClickHaveAllreadyAccompte = (event) => {
    event.preventDefault();
    setPasswordConfirmState('login');
    setRedirectLoginState(true);
  }

  /**
   *
   * @param {object} event
   */
  const handleOnChangeNewPassword = (event) => {
    setNewPasswordState(event.target.value);
  }

  const handleChangeLoginPassword = (event) => {
    let dataLogin = Object.assign({}, dataLoginState);
    if(event.target.name === 'inputLoginEmail') {
      dataLogin.login = event.target.value;
    } else {
      dataLogin.password = event.target.value;
    }
    setDataLoginState(dataLogin);
  }

  const handleChangeLoginForgotState = (event) => {
    setLoginForgotState(event.target.value);
  }


  /*const reSendCodeVerif = (event) => {
    //setPasswordConfirmState( 'confirmEmail' );

    //handleSubmit();
  }*/

  /**
   * Submit du form
   * @param {object} event
   */
  const handleSubmit = (event) => {

    let form = event.target.closest('form');
    let btn = event.target;
    let submitId = btn.id;
    // reSendCodeVerif

    // RESET DES MESSAGES
    setMessageInfoState('')

    if(btn.classList.contains('loading') === false) {
      btn.classList.add('loading');
      let data = new FormData(form);
      // if (passwordConfirmState === 'login' || true) {
        if (stageState === 'forgot' || stageState === 'first') {
          let test = Utility.checkValue('inputForgotEmail', data.get('inputForgotEmail'), 'email');
          if (test.error === false) {
            data.set('mail', data.get('inputForgotEmail'));
            data.set('stageState', stageState);

            data.delete('inputLoginEmail');
            data.delete('inputLoginPassword');
            data.delete('inputForgotEmail');

            //data = new URLSearchParams(data);
            API
              .postForm(`/${token}/${lang}/resetPasswordAction`, data)
              .then(response => {
                ResponseManagement(response,
                  () => {

                    if(response.data.data.isMailSend === true) {
                      toast.success(response.data.data.message);
                      // setStage('login');
                      setStageState('loginStepEmail');
                      setPasswordConfirmState('loginStepEmail');
                    } else {
                      setMessageInfoState(response.message)
                      // toast.error(response.message);
                    }
                  },
                  () => {
                    toast.error(response.data.message);
                  }
                );
                btn.classList.remove('loading');
              })
              .catch((error) => {
                ErrorManagement(error, () => { });
                btn.classList.remove('loading');
              });
          } else {
            toast.error(translationsState.enterEmail);
            btn.classList.remove('loading');
          }
        }

      else if (passwordConfirmState === 'loginStepEmail') {
        const loginEmail = data.get('inputLoginEmail');
        if (loginEmail.trim().length > 0) {
          data.set('login', loginEmail);
          data.set('fct', 'checkEmail');

          data.delete('inputForgotEmail');
          data.delete('inputLoginEmail');
          data.delete('inputLoginPassword');

          //data = new URLSearchParams(data);

          API
          .postForm(`/${token}/${lang}/connectionAction`, data)
          .then(response => {
            ResponseManagement(response,
                () => {
                  const langEtab = lang;
                  const tokenCustomerArea = Utility.getTemporaryLinkTokenSegment(response.data.data?.token);

                  setTokenCustomerAreaState(tokenCustomerArea)

                  // verif email valide OTA !
                  setIsMailValidState(response.data.data.isMailValid);
                 
                  // has login
                  if (response.data.data.customerAreaLogin) {
                    // form connexion password
                    if (response.data.data.hasMdp) {

            
                      setStageState('loginStepPassword');
                      setPasswordConfirmState('loginStepPassword');
                      //setMessageInfoState('fillPasswordRequest');
                      setMessageInfoState(translationsState.fillPasswordRequest);
                      btn.classList.remove('loading');
                    }
                    else if( !response.data.data.isMailValid ) { 
                      setPasswordConfirmState('confirmEmail');
                    }
                    else {
                      // !!!!!!!!!!!!!!! PAS BON, DU COUP PLUS DE GESTION DES EMAIL OTA !!!!!!!!!!!!!!!!!!
                      // On bifurque direct vers l'envoie d'un code de vérif
                      data = new FormData();
                      setCustomerAreaMailState( response.data.data.customerAreaLogin );
                      setIsInitializePasswordWithCodeState(true)
                      data.set('mail', response.data.data.customerAreaLogin);
                      data.set('verifJusteEmail', true);
                      data.set('initializePasswordWithCode', true);
                      //data = new URLSearchParams(data);

                      API
                          .postForm(`/${tokenCustomerArea}/${langEtab}/initializePasswordAction`, data)
                          .then(response => {
                            ResponseManagement(response,
                                () => {

                                  //setIsMailValidState(false)

                                  if (response.data.data.hasMdp === 'false' && response.data.data.hasDoublon === 'false') {
                                    //ALORS LE MAIL EST PARTI, ON ENVOIE LA VUE POUR CHECK LE CODE
                                    setPasswordConfirmState('enterCodeToValidIsMyAccount')
                                    // setLoaderActiveState(false);
                                    btn.classList.remove('loading');
                                  }
                                })
                          })

                      // setPasswordConfirmState('confirmEmail');
                      // setIsMailValidState(false)
                      // setPasswordConfirmState('')
                    }
                  }

                  if (response.data.data.message) {
                    setMessageInfoState(translationsState[response.data.data.message])
                    btn.classList.remove('loading');
                  }



                },
                () => {
                  setDataLoginState({
                    login : '',
                    password : ''
                  })

                  setMessageInfoState(translationsState[response.data.message] ?? response.data.message)
                  // toast.error(response.data.message);
                }
            );
          })
          .catch((error) => {
            ErrorManagement(error, () => { });
            btn.classList.remove('loading');
          });
        } else {
          btn.classList.remove('loading');
          //setMessageInfoState('noLoginFilled')
          setMessageInfoState(translationsState.noLoginFilled)
        }

      }

      else if (passwordConfirmState === 'loginStepPassword') {
        const loginPassword = data.get('inputLoginPassword');

        if (loginPassword.trim().length > 0) {
          data.set('login', dataLoginState.login);
          data.set('password', loginPassword);
          data.set('fct', 'checkLogin');

          data.delete('inputForgotEmail');
          data.delete('inputLoginEmail');
          data.delete('inputLoginPassword');

          //data = new URLSearchParams(data);

          API
          .postForm(`/${token}/${lang}/connectionAction`, data)
          .then(response => {
            ResponseManagement(response,
                () => {
                  const langEtab = lang;

                  if (response.data.data.isConnected) {
                    Auth.login(langEtab, true, {codePage: null, id:null}, () => {
                      navigate(`/${token}/${langEtab}`);
                    });
                  }

                  if (response.data.data.message) {
                    setMessageInfoState(translationsState[response.data.data.message])
                    btn.classList.remove('loading');
                  }

                },
                () => {
                  setDataLoginState({
                    login : '',
                    password : ''
                  })

                  setStageState('loginStepEmail')
                  toast.error(response.data.message);
                }
            );
            btn.classList.remove('loading');
          })
          .catch((error) => {
            ErrorManagement(error, () => { });
            btn.classList.remove('loading');
          });
        } else {
          btn.classList.remove('loading');
          //setMessageInfoState('noPasswordFilled');
          setMessageInfoState(translationsState.noPasswordFilled);
        }

      }

      else {
        let errorDetect = false;
        let error = {
          newPassword: false,
          confirmPassword: false,
          mail: false
        }
        // envoie code de confirmation
        if( passwordConfirmState === 'confirmEmail' || submitId === 'reSendCodeVerif' ){


          //data = new URLSearchParams(data);

          setCustomerAreaMailState( data.get('inputMail') );
          data.set('mail', data.get('inputMail'));
          data.delete('inputMail');

          data.set('verifJusteEmail', true);
          data.set('initializePasswordWithCode', isInitializePasswordWithCodeState);

          let input = 'mail'
          let test = Utility.checkValue(input, data.get(input), 'email');
          if (test.error === true) {
            errorDetect = true;
          }

        }
        // verif du code de confirmation
        else if( passwordConfirmState === 'enterCodeToValidIsMyAccount' ){
          //data = new URLSearchParams(data);

          setCustomerAreaMailState( data.get('inputMail') );
          data.set('mail', data.get('inputMail'));
          data.delete('inputMail');
          data.set('codeVerif', data.get('inputCodeVerif'));
          data.delete('inputCodeVerif');

          data.set('verifCodeToValideMail', true);
          data.set('initializePasswordWithCode', isInitializePasswordWithCodeState);

          let input = 'mail'
          let test = Utility.checkValue(input, data.get(input), 'email');
          if (test.error === true) {
            errorDetect = true;
          }

          if (!Utility.isVerificationCodeFilled(data.get('codeVerif'))) {
            errorDetect = true;
            toast.error(translationsState.error_code_required);
          }

        }
        // verif mdp
        else if( passwordConfirmState === 'connectToValidIsMyAccount' ){

          //data = new URLSearchParams(data);

          setCustomerAreaMailState( data.get('inputMail') );
          data.set('mail', data.get('inputMail'));
          data.delete('inputMail');
          data.set('loginPassword', data.get('inputLoginPassword'));
          data.delete('inputLoginPassword');

          data.set('connectToValidIsMyAccount', true);

          let input = 'mail'
          let test = Utility.checkValue(input, data.get(input), 'email');
          if (test.error === true) {
            errorDetect = true;
          }
        }
        else{

          //data = new URLSearchParams(data);

          data.set('newPassword', data.get('inputConfirmPassword'));
          data.set('confirmPassword', data.get('inputConfirmPasswordBis'));
          data.delete('inputConfirmPassword');
          data.delete('inputConfirmPasswordBis');

          for (let input of ['newPassword', 'confirmPassword']) {// eslint-disable-line no-unused-vars
            let test = Utility.checkValue(input, data.get(input), 'password');
            if (test.error === true) {
              errorDetect = true;
              error[input] = true;
            }
          }

          if(isMailValidState === false) {

            setCustomerAreaMailState( data.get('inputMail') );
            data.set('mail', data.get('inputMail'));
            data.delete('inputMail');

            let input = 'mail'
            let test = Utility.checkValue(input, data.get(input), 'email');
            if (test.error === true) {
              errorDetect = true;
              error[input] = true;
            }
          }

          if (errorDetect === false) {
            if (data.get('newPassword') !== data.get('confirmPassword')) {
              errorDetect = true;
              toast.error(translationsState.msgErrorChangePassWordNonIdentique);
              error.newPassword = true;
              error.confirmPassword = true;
            }
          } else {
            toast.error(translationsState.passwordRequired);
          }

          setErrorPasswordInitState(error);
        }

        // envoie de l'ajax
        if (errorDetect === false) {

          API
            .postForm(`/${Utility.getTemporaryLinkTokenSegment(tokenCustomerAreaState)}/${lang}/initializePasswordAction`, data)
            .then(response => {
              ResponseManagement(response,
                () => {

                  // doublon affiche mdp pour confirmer espace client
                  if( (passwordConfirmState == "confirmEmail" || submitId === 'reSendCodeVerif') && response.data.data.hasDoublon == 'true' ){
                    setInfoUserState({
                      civility : response.data.data.user.civility,
                      lastName : response.data.data.user.lastName,
                      firstName : response.data.data.user.firstName
                    });
                    if( response.data.data.hasMdp == 'true' ){
                      setPasswordConfirmState('connectToValidIsMyAccount');
                    }
                    else{
                      setPasswordConfirmState('enterCodeToValidIsMyAccount');
                    }

                  }
                  // pas doublon affiche création mdp
                  else if( passwordConfirmState == "confirmEmail" && response.data.data.hasDoublon == 'false'){
                    setPasswordConfirmState('enterCodeToValidIsMyAccount');
                    //setPasswordConfirmState('initializePassword');
                  }
                  // pas de doublon, initialization du mot de passe
                  else if( passwordConfirmState == "enterCodeToValidIsMyAccount" && response.data.data.hasDoublon == 'false' ){
                    if( response.data.data.hasVerifCodeOk == 'true' ){
                      setIsMailValidState(true);
                      setTokenCustomerAreaState(Utility.getPasswordStepToken(response.data.data.newToken, tokenCustomerAreaState));
                      setPasswordConfirmState('initializePassword');
                    }
                    else if (submitId !== 'reSendCodeVerif'){
                      // code non valide
                      toast.error( translationsState.error_code_non_valid );
                    }
                  }
                  // apres dedoublonement, initialization du mot de passe ou login
                  else if(passwordConfirmState == "enterCodeToValidIsMyAccount" && response.data.data.hasDoublon == 'true' ){
                    if( passwordConfirmState == "enterCodeToValidIsMyAccount" && response.data.data.hasVerifCodeOk == 'true' ){
                      // TODO : recharger la page avec nouveau token...
                      if ( typeof response.data.data.newToken != 'undefined' && response.data.data.newToken != "" ) {
                        setIsMailValidState(true);
                        
                        const page = response.data.data.goto;

                        setDataLoginState({
                          login : response.data.data.user.mail,
                          password : ''
                        });

                        if (page == "login") {
                          setPasswordConfirmState('login');
                          setRedirectLoginState(true);
                        }
                        else{
                          setTokenCustomerAreaState(Utility.getPasswordStepToken(response.data.data.newToken, tokenCustomerAreaState));
                          setPasswordConfirmState('initializePassword');
                        }

                        Auth.login(lang, false, {codePage: null, id:null}, () => {
                          navigate(`/${token}/${lang}/${page}`);
                        });
                      }
                    }
                    else if (submitId !== 'reSendCodeVerif') {
                      // code non valide
                      toast.error( translationsState.error_code_non_valid );
                    }

                  }
                  // login apres verif mot de passe
                  else if(  passwordConfirmState == "connectToValidIsMyAccount" && response.data.data.isConnected == true ) {
                    Auth.login(lang, true, {codePage: null, id:null}, () => {
                      navigate(`/${token}/${lang}`);
                    } );
                  }
                  // login apres création mot de passe
                  else if (response.data.data.isConnected) {
                    Auth.login(lang, true, {codePage: null, id:null}, () => {
                      navigate(`/${token}/${lang}`);
                    });
                  }

                },
                () => {

                  // retour fiche avec espace client deja existant
                  if( typeof response.data.message !== "undefined" && response.data.message !== "" && response.data.message == 'error_mail_doublon' ){
                    setAffChampCodeVerifState(true);
                    setPasswordConfirmState('codeVerif');
                    // stock email
                    let data = new FormData(form);
                  }
                  // message
                  if( typeof response.data.message !== "undefined" && response.data.message !== "" ){

                    toast.error( translationsState[response.data.message] );
                  }
                  else{
                    displayToastErrorFromResponse(response)
                  }

                }
              );
              btn.classList.remove('loading');
            })
            .catch((err, ) => {
              ErrorManagement(error, () => { });
              btn.classList.remove('loading');
            })
        } else {
          btn.classList.remove('loading');
        }
      }
    }
  }

  /**
   * Affichage du mot de passe en claire
   * @param {object} event
   */
  const handleClickShowPassword = (event) => {
    let name = event.target.closest('div.input').querySelector('input').name;
    if (name === 'inputConfirmPassword') {
      setTypeInputConfirmPasswordState('text');
      let timeOutShowNewPassword = setTimeout(() => {
        setTypeInputConfirmPasswordState('password');
        window.clearTimeout(timeOutShowNewPassword);
      }, 1500);
    } else if (name === 'inputConfirmPasswordBis') {
      setTypeInputConfirmPasswordBisState('text');
      let timeOutShowConfirmPassword = setTimeout(() => {
        setTypeInputConfirmPasswordBisState('password');
        window.clearTimeout(timeOutShowConfirmPassword);
      }, 1500);
    }
  }

  /**
   * Retourne le header
   * @param {string} type
   * @returns {object} jsx
   */
  const getHeader = (type) => {
    let title;
    switch (type) {
      case 'new':
        title = translationsState.initializationPassword;
        break;
      case 'forgot':
        title = translationsState.resetPassword;
        break;
      case 'first':
        title = translationsState.passwordForgot;
        break;
      case 'confirmEmail':
        title = translationsState.confirmEmail;
        break;
      case 'enterCodeToValidIsMyAccount':
        title = translationsState.enterCodeToValidIsMyAccount;
        break;
      case 'connectToValidIsMyAccount':
        title = translationsState.hello;
        if ( infoUserState.civility != false) {
          title += " " + infoUserState.civility;
        }
        if ( infoUserState.lastName != false) {
          title += " " + infoUserState.lastName;
        }
        if ( infoUserState.firstName != false) {
          title += " " + infoUserState.firstName;
        }
        break;
      default:
        title = translationsState.connection;
        break;
    }

    return (
      <div>
        <Header as="h2" color="black" textAlign="left" className="mt-3 mb-2">
          {title}
        </Header>
      </div>
    )
  }

  /**
   * Retourne le logo de l'etablissement
   * @returns {object} jsx
   */
  const getImage = () => {
    if ( logoState ) {
      return <Image style={{ margin: 'auto' }} src={logoState} />
    } else {
      return <Header as="h1">{establishmentState.nomEtab}</Header>
    }
  }

  /**
   * Retourne le formulaire
   * @returns Object jsx
   */
  const getForm = () => {
    let form = [];
    if (passwordConfirmState === 'loginStepEmail') {
      // form.push(getFormLogin());
      form.push(getFormLoginV2_step_email());
      // form.push(getFormForgotPassWord());
    } 
    else if (passwordConfirmState === 'loginStepPassword') {
      form.push(getFormLoginV2_step_password());
    }
    else if (passwordConfirmState === 'forgot' || passwordConfirmState === 'first') {
      form.push(getFormForgotPassWord());
    }
    else if( passwordConfirmState === 'initializePassword' ){
      form.push(getFormConfirmPassword());
    }
    else if ( passwordConfirmState === 'enterCodeToValidIsMyAccount' ){
      form.push(getFormEnterCodeToValidIsMyAccount());
    }
    else if ( passwordConfirmState === 'connectToValidIsMyAccount' ){
      form.push(getFormConnectToValidIsMyAccount());
    }
    else if( !isMailValidState ){
      form.push(getFormConfirmEmail());
    }
    else {
      form.push(getFormConfirmPassword());
    }

    return (
      <Form name="formLogin" size="large">
        <Segment stacked className="p-4 segmentNotBoxShadow">
          {getImage()}
          { messageInfoState != '' ?
            <Message
              className="mb-0"
              info
              content = {messageInfoState}
            />
            : ''}
          <div id="divSlide">
            <List horizontal>
              {form}
            </List>
          </div>
        </Segment>
      </Form>
    )
  }

  /**
   * Retourne le formulaire du login
   * @returns {object} jsx
   */
  const getFormLogin = () => {

    return (
      <List.Item key="login" id="blockLogin">
        {getHeader('login')}
        <Form.Input
          type="email"
          fluid
          icon="user"
          iconPosition="left"
          placeholder={translationsState.addressMail}
          value={dataLoginState.login}
          name="inputLoginEmail"
          onChange={handleChangeLoginPassword}
        // pattern={Utility.getPattern('mail')}
          // required
        />
        <Form.Input
          fluid
          icon="lock"
          iconPosition="left"
          placeholder={translationsState.password}
          type="password"
          value={dataLoginState.password}
          name="inputLoginPassword"
          onChange={handleChangeLoginPassword}
        // pattern={Utility.getPattern('password')}
          // required
        />
        <div className="ui left aligned container ">
          <a href="#login" onClick={handleClickUrlPassWordforgot}>{translationsState.passwordForgot}&nbsp;?</a>
          <a href="#login" onClick={handleClickUrlFirstConnexion}>{translationsState.firstConnexion}</a>
        </div>
        <div className="ui right aligned container ">
          <Button primary size="large" onClick={handleSubmit}>
            {translationsState.connection}
          </Button>
        </div>
      </List.Item>
    )
  }

  /**
   * Retourne le formulaire du login V2 step email
   * @returns {object} jsx
   */
  const getFormLoginV2_step_email = () => {

    return (
        <List.Item key="login" id="blockLogin">
          {getHeader('login')}
          <Form.Input
              type="email"
              fluid
              icon="user"
              iconPosition="left"
              placeholder={translationsState.addressMail}
              value={dataLoginState.login}
              name="inputLoginEmail"
              onChange={handleChangeLoginPassword}
              // pattern={Utility.getPattern('mail')}
              // required
          />

          <div className="ui left aligned container ">
            <a href="#login" onClick={handleClickUrlPassWordforgot}>{translationsState.passwordForgot}</a>
          </div>
          <div className="ui right aligned container ">
            <Button primary size="large" onClick={handleSubmit} className="mr-0">
              {translationsState.connection}
            </Button>
          </div>
        </List.Item>
    )
  }

  /**
   * Retourne le formulaire du login V2 step password
   * @returns {object} jsx
   */
  const getFormLoginV2_step_password = () => {

    return (
        <List.Item key="loginStepPassword" id="blockLoginPassword">
          {getHeader('login')}

          <Form.Input
              type="email"
              fluid
              icon="user"
              iconPosition="left"
              placeholder={translationsState.addressMail}
              value={dataLoginState.login}
              name="inputLoginEmail"
              onChange={handleChangeLoginPassword}
              disabled
              // pattern={Utility.getPattern('mail')}
              // required
          />
          <Form.Input
              fluid
              icon="lock"
              iconPosition="left"
              placeholder={translationsState.password}
              type="password"
              value={dataLoginState.password}
              name="inputLoginPassword"
              onChange={handleChangeLoginPassword}
              // pattern={Utility.getPattern('password')}
              // required
          />
          <div className="ui left aligned container ">
            <a href="#login" onClick={handleClickUrlPassWordforgot}>{translationsState.passwordForgot}&nbsp;?</a>
          </div>
          <div className="ui left aligned container mt-3">
            <a href="#forgot" onClick={() => {
              setPasswordConfirmState('loginStepEmail')
              setStageState('loginStepEmail')
              setMessageInfoState('')
            }}>
              <Icon name="arrow left" />
              {translationsState.back}
            </a>
          </div>
          <div className="ui right aligned container ">
            <Button primary size="large" onClick={handleSubmit} className="mr-0">
              {translationsState.connection}
            </Button>
          </div>
        </List.Item>
    )
  }

  /**
   * Retourne le formulaire pour le mot de passe oublié
   * @returns {object} jsx
   */
  const getFormForgotPassWord = () => {

    return (
      <List.Item key="forgot" id="blockForgot">
        { stageState === 'forgot'
         ? getHeader('forgot')
         : getHeader('first')
        }
        <Form.Input
          type="email"
          fluid
          icon="user"
          iconPosition="left"
          placeholder={translationsState.addressMail}
          value={loginForgotState}
          onChange={handleChangeLoginForgotState}
          name="inputForgotEmail"
        // pattern={Utility.getPattern('mail')}
        />
        <div className="field inputHidden" ></div>
        <div className="ui left aligned container ">
          <a href="#forgot" onClick={handleClickUrlBack}>
            <Icon name="arrow left" />
            {translationsState.back}
          </a>
        </div>
        <div className="ui right aligned container ">

          <Button primary size="large" onClick={handleSubmit} className="mr-0">
            {translationsState.validate}
          </Button>
        </div>
      </List.Item>
    )
  }

  /**
   * Retourne le formulaire de confirmation du mot de passe
   * @returns {object} jsx
   */
  const getFormConfirmPassword = () => {
    return (
      <List.Item key="confirmPassword">
        {getHeader('new')}

        {
          customerAreaMailState !== null ?
            <Form.Input
              fluid
              icon={<Icon name="user" />}
              pattern={Utility.getPattern('email')}
              name="inputMail"
              value={customerAreaMailState}
              disabled
            />
          :
            null
        }

        <Form.Input
          fluid
          icon={<Icon name="eye" link onClick={handleClickShowPassword} />}
          placeholder={translationsState.password}
          type={typeInputConfirmPasswordState}
          onChange={handleOnChangeNewPassword}
          error={errorPasswordInitState.newPassword}
          // pattern={Utility.getPattern('password')}
          //required
          name="inputConfirmPassword"
        />
        <Form.Input
          fluid
          icon={<Icon name="eye" link onClick={handleClickShowPassword} />}
          placeholder={translationsState.confirmPassword}
          type={typeInputConfirmPasswordBisState}
          error={errorPasswordInitState.confirmPassword}
          // pattern={Utility.getPattern('password')}
          //required
          name="inputConfirmPasswordBis"
        />

        {
          <CheckPassword password={newPasswordState} translations={{
            contentPasswordUpperCase: translationsState.contentPasswordUpperCase,
            contentPasswordLowerCase: translationsState.contentPasswordLowerCase,
            contentPasswordNumberCase: translationsState.contentPasswordNumberCase,
            contentPasswordMinCharsCase: translationsState.contentPasswordMinCharsCase,
            contentPassword: translationsState.contentPassword
          }} />
        }
        <div className="ui left aligned container ">
          <a href="#login" onClick={handleClickHaveAllreadyAccompte}>{translationsState.haveAllreadyAccompte}</a>
        </div>
        <div className="ui right aligned container ">
          <Button primary size="large"  onClick={handleSubmit} className="mr-0">
            {translationsState.createMonMotDePass}
          </Button>
        </div>
      </List.Item>
    )
  }

  /**
   * Retourne le formulaire de confirmation du code pour verifier l'email
   * @returns {object} jsx
  */
  const getFormConfirmEmail = () => {

    return (
      <List.Item key="confirmEmail">

        {getHeader('confirmEmail')}

        <Message info>
          { translationsState.infoConfirmEmail }
        </Message>

        <Form.Input
          fluid
          icon={<Icon name="mail"/>}
          iconPosition="left"
          placeholder={translationsState.enterEmail}
          type="text"
          //onChange={handleOnChangeNewPassword}
          error={errorPasswordInitState.mail}
          pattern={Utility.getPattern('email')}
          // required
          //disabled={ affChampCodeVerifState }
          name="inputMail"
        />

        <div className="ui right aligned container ">
          <Button primary size="large"  onClick={handleSubmit} className="mr-0">
            {translationsState.validate}
          </Button>
        </div>

      </List.Item>
    )
  }

  /**
   * Retourne formulaire de connexion pour valider compte client lié
   * @returns {object} jsx
   */
  const getFormConnectToValidIsMyAccount = () => {

    return (
      <List.Item key="connectToValidIsMyAccount">

        {getHeader('connectToValidIsMyAccount')}

        <Message info>
          { translationsState.infoConnectToConfirmAccount }
        </Message>

        {/* Email */}
        <Form.Input
          fluid
          icon={<Icon name="mail"/>}
          iconPosition="left"
          placeholder={translationsState.enterEmail}
          type="text"
          value={ customerAreaMailState }
          //onChange={handleOnChangeNewPassword}
          error={errorPasswordInitState.mail}
          pattern={Utility.getPattern('email')}
          // required
          //disabled={ affChampCodeVerifState }
          name="inputMail"
        />

        {/* Mdp */}
        <Form.Input
          fluid
          icon="lock"
          iconPosition="left"
          placeholder={translationsState.password}
          type="password"
          name="inputLoginPassword"
        />

        { /* Mdp oublie */
        <div className="ui left aligned container ">
          <a href="#login" onClick={handleClickUrlPassWordforgot}>{translationsState.passwordForgot}&nbsp;?</a>
        </div> }

        {/* Valider */}
        <div className="ui right aligned container ">
          <Button primary size="large"  onClick={handleSubmit} className="mr-0">
            {translationsState.validate}
          </Button>
        </div>

      </List.Item>
    )

  }

  /**
   * Retourne formulaire pour verifier code
   * @returns {object} jsx
   */
  const getFormEnterCodeToValidIsMyAccount = () => {

    return (
      <List.Item key="enterCodeToValidIsMyAccount">

        {getHeader('enterCodeToValidIsMyAccount')}

        <Message info>
          { translationsState.infoEnterCodeToValidMyAccount }
        </Message>

        {/* Email */}
        <Form.Input
          fluid
          icon={<Icon name="mail"/>}
          iconPosition="left"
          placeholder={translationsState.enterEmail}
          type="text"
          value={ customerAreaMailState }
          error={errorPasswordInitState.mail}
          pattern={Utility.getPattern('email')}
          name="inputMail"
          //disabled={true}
        />

        {/* Code */}
        <Form.Input
          fluid
          placeholder={translationsState.enterCode  }
          type="text"
          name="inputCodeVerif"
          className="uppercase"
        />

        {/* renvoyer le code */}
        <div className="ui right aligned container ">
          <Button id="reSendCodeVerif" primary size="large" onClick={handleSubmit}>
            {translationsState.reSendCodeVerif}
          </Button>
        {/* Valider */}
          <Button primary size="large"  onClick={handleSubmit} className="mr-0">
            {translationsState.validate}
          </Button>
        </div>

      </List.Item>
    )

  }

  /**
   * Retourne le loader de la page
   * @returns {object} jsx
   */
  const getLoader = () => {
    return (
      <Dimmer active={loaderActiveState} inverted>
        <Loader inverted content={(lang === 'FR') ? 'Chargement' : 'Loading'} />
      </Dimmer>
    )
  }

  let styleModule = {
    backgroundImage: "url('" + ((backgroundImageState) ? backgroundImageState : null) + "')",
    marginTop: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }

  const renderRedirect404 = () => {
    if (redirectState) {
      return <Navigate to="/" />
    }
  }

  const renderRedirectLogin = () => {
    if (redirectLoginState) {
      let url = "/" + token + "/" + lang +"/login";
      return <Navigate to={url} />
    }
  }

  /**
   * Rendu du module
   * @returns {object} jsx
   */
  return (
    <div id="loginBox">
      {renderRedirect404()}
      {renderRedirectLogin()}
      <Loader active={loaderActiveState} />
      <Grid textAlign="center" verticalAlign="middle" style={backgroundImageState ? styleModule : {}}>
        <Grid.Column style={{ maxWidth: 450 }}>
          {getForm()}
        </Grid.Column>
      </Grid>
      <CookieBanner token={token} lang={lang} translations={translationsState} legalInfo={legalInfoState} />
    </div>
  );
}

export default LoginBox
